import { render, staticRenderFns } from "./bindStudentListDialog.vue?vue&type=template&id=ffdb06dc&scoped=true"
import script from "./bindStudentListDialog.vue?vue&type=script&lang=js"
export * from "./bindStudentListDialog.vue?vue&type=script&lang=js"
import style0 from "./bindStudentListDialog.vue?vue&type=style&index=0&id=ffdb06dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdb06dc",
  null
  
)

export default component.exports